export function minifyLocationLabel(label: string) {
  const index = label.indexOf(',',label.indexOf(',')+1)
  return label.slice(0, index);
}
